
    import '/home/ec2-user/Youlify-Design/components/empty/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["empty-demo-basic","empty-demo-simple","empty-demo-customize","empty-demo-config-provider","empty-demo-description","empty-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/empty/index.en-US.md?type=demo')
};